import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  server: {
    ANALYZE: z
      .enum(['true', 'false'])
      .optional()
      .transform((value) => value === 'true'),
    OPENAI_API_KEY: z.string({
      required_error: 'OPENAI_API_KEY environment variable is required for AI features',
    }),
    ROLLBAR_CLIENT_SERVER_TOKEN: z.string().optional(),
  },
  // IMPORTANT: When adding new client-side env vars, you will need to also add them to the GHA secrets:
  // https://github.com/govinity/govinity-app/settings/secrets/actions and to .github/workflows/a11y-staging-crawl.yml
  client: {
    NEXT_PUBLIC_APP_ENV: z.enum([
      'development',
      'production',
      'test',
      'staging',
      'integration',
      'preview',
    ]),
    NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_ID: z.string(),
    NEXT_PUBLIC_PUBLIC_API_URL: z.url(),
    NEXT_PUBLIC_MUX_DATA_ENV_KEY: z.string().optional(),
    NEXT_PUBLIC_USER_API_URL: z.url(),
    NEXT_PUBLIC_INTERNAL_CLIENT_URL: z.url(),
    NEXT_PUBLIC_REALTIME_SERVICE_URL: z.url(),
    NEXT_PUBLIC_CODE_VERSION: z.string(),
    NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN: z
      .string()
      .nullish()
      .refine(
        (value) => {
          // In deployed environments, NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN must be set
          if (['production', 'staging', 'integration'].includes(process.env.NEXT_PUBLIC_APP_ENV)) {
            return !!value;
          }
          return true; // Optional in other environments
        },
        {
          message:
            'NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN environment variable is required in production',
        }
      ),
  },
  runtimeEnv: {
    ANALYZE: process.env.ANALYZE,
    OPENAI_API_KEY: process.env.OPENAI_API_KEY,
    ROLLBAR_CLIENT_SERVER_TOKEN: process.env.ROLLBAR_CLIENT_SERVER_TOKEN,
    NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
    NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_ID: process.env.NEXT_PUBLIC_LAUNCHDARKLY_CLIENT_ID,
    NEXT_PUBLIC_PUBLIC_API_URL: process.env.NEXT_PUBLIC_PUBLIC_API_URL,
    NEXT_PUBLIC_MUX_DATA_ENV_KEY: process.env.NEXT_PUBLIC_MUX_DATA_ENV_KEY,
    NEXT_PUBLIC_USER_API_URL: process.env.NEXT_PUBLIC_USER_API_URL,
    NEXT_PUBLIC_INTERNAL_CLIENT_URL: process.env.NEXT_PUBLIC_INTERNAL_CLIENT_URL,
    NEXT_PUBLIC_REALTIME_SERVICE_URL: process.env.NEXT_PUBLIC_REALTIME_SERVICE_URL,
    NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN: process.env.NEXT_PUBLIC_ROLLBAR_CLIENT_TOKEN,
    NEXT_PUBLIC_CODE_VERSION:
      process.env.VERCEL_GIT_COMMIT_SHA || process.env.NEXT_PUBLIC_CODE_VERSION || 'development',
  },
});
